var _path, _path2, _g, _path3, _path4, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 9.0041C17.3332 13.5949 13.5928 17.3334 8.99984 17.3334C4.40685 17.3334 0.666504 13.5949 0.666504 9.0041C0.666504 4.40529 4.40685 0.666748 8.99984 0.666748C13.5928 0.666748 17.3332 4.40529 17.3332 9.0041Z",
    fill: "#F9B42A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1125_6588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 9.0041C17.3332 13.5949 13.5928 17.3334 8.99984 17.3334C4.40685 17.3334 0.666504 13.5949 0.666504 9.0041C0.666504 4.40529 4.40685 0.666748 8.99984 0.666748C13.5928 0.666748 17.3332 4.40529 17.3332 9.0041Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1125_6588)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.2402,
    y: -2.30054,
    width: 12,
    height: 24,
    transform: "rotate(19.0283 15.2402 -2.30054)",
    fill: "#C4C4C4",
    fillOpacity: 0.19
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 9.00523C13.1665 9.26849 13.0813 9.53277 12.9108 9.74439C12.8789 9.78591 12.7297 9.95703 12.6125 10.0684L12.5486 10.1292C11.6537 11.0516 9.42716 12.4388 8.2979 12.8833C8.2979 12.8934 7.62673 13.1577 7.30713 13.1668H7.26452C6.77446 13.1668 6.31636 12.9046 6.08199 12.4793C5.95415 12.2454 5.83696 11.567 5.82631 11.5579C5.73042 10.9493 5.6665 10.0178 5.6665 8.9951C5.6665 7.9228 5.73042 6.94974 5.84761 6.35233C5.84761 6.3422 5.9648 5.79542 6.03937 5.61316C6.15656 5.35091 6.36963 5.12714 6.63596 4.98538C6.84903 4.88514 7.07275 4.8335 7.30713 4.8335C7.55216 4.84463 8.01025 4.9955 8.19136 5.06638C9.38454 5.51191 11.6644 6.96999 12.538 7.86104C12.6871 8.0028 12.8469 8.17594 12.8895 8.21543C13.0706 8.43819 13.1665 8.71158 13.1665 9.00523Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1125_6588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 9,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 9.00523C13.1665 9.26849 13.0813 9.53277 12.9108 9.74439C12.8789 9.78591 12.7297 9.95703 12.6125 10.0684L12.5486 10.1292C11.6537 11.0516 9.42716 12.4388 8.2979 12.8833C8.2979 12.8934 7.62673 13.1577 7.30713 13.1668H7.26452C6.77446 13.1668 6.31636 12.9046 6.08199 12.4793C5.95415 12.2454 5.83696 11.567 5.82631 11.5579C5.73042 10.9493 5.6665 10.0178 5.6665 8.9951C5.6665 7.9228 5.73042 6.94974 5.84761 6.35233C5.84761 6.3422 5.9648 5.79542 6.03937 5.61316C6.15656 5.35091 6.36963 5.12714 6.63596 4.98538C6.84903 4.88514 7.07275 4.8335 7.30713 4.8335C7.55216 4.84463 8.01025 4.9955 8.19136 5.06638C9.38454 5.51191 11.6644 6.96999 12.538 7.86104C12.6871 8.0028 12.8469 8.17594 12.8895 8.21543C13.0706 8.43819 13.1665 8.71158 13.1665 9.00523Z",
    fill: "#F9B42A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1125_6588)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 9.90869,
    y: 5.38354,
    width: 8.33333,
    height: 9.16667,
    transform: "rotate(19.2295 9.90869 5.38354)",
    fill: "#C9C9C9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.8952db40.svg";
export { ForwardRef as ReactComponent };